import { BrandListerActionTypes } from '../../../enums/ActionEnums';
import { LOCATION_CHANGE } from 'connected-react-router';
export const initialState = {
    items: [],
    filters: [],
    popularList: {},
};
const setActiveFilter = (filters, filterToActivate) => {
    return filters.map(filter => (Object.assign(Object.assign({}, filter), { active: filter.key === filterToActivate })));
};
export const loadBrandListerReducer = (initialData = {}) => {
    const initialReducerState = Object.assign(Object.assign({}, initialState), initialData);
    return (state = initialReducerState, action) => {
        var _a, _b, _c;
        switch (action.type) {
            case LOCATION_CHANGE:
                return ((_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.brandLister) ? Object.assign({}, action.payload.location.state.brandLister) : state;
            case BrandListerActionTypes.SET_FILTER:
                return Object.assign(Object.assign({}, state), { filters: setActiveFilter(state.filters, action.payload) });
            default:
                return state;
        }
    };
};
export const brandListerReducer = loadBrandListerReducer();
